import React, { useState, useEffect, useMemo } from 'react';
import {
  Box,
  Heading,
  Button,
  Card,
  CardBody,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  Select,
  useToast,
  HStack,
  Badge,
  IconButton,
  VStack,
  Text,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  InputGroup,
  InputRightElement,
  Spinner,
  useBreakpointValue,
  Icon,
  SimpleGrid,
} from '@chakra-ui/react';
import DataTable from 'react-data-table-component';
import { FiEdit, FiTrash2, FiPlus, FiRefreshCw, FiSearch } from 'react-icons/fi';
import * as FiIcons from 'react-icons/fi';
import { menuSubCategoryApi, menuCategoryApi } from '../config/api';

const toSecureUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http://')) return `https://${url.slice(7)}`;
  if (url.startsWith('https://')) return url;
  return `${window.location.origin}${url.startsWith('/') ? url : `/${url}`}`;
};

const ManageMenuSubCategory = () => {
  const [subCategories, setSubCategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [editingSubCategory, setEditingSubCategory] = useState(null);
  const [deleteSubCategory, setDeleteSubCategory] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('');
  const toast = useToast();
  
  const { isOpen: isFormOpen, onOpen: onFormOpen, onClose: onFormClose } = useDisclosure();
  const { isOpen: isDeleteOpen, onOpen: onDeleteOpen, onClose: onDeleteClose } = useDisclosure();
  const cancelRef = React.useRef();

  const [formData, setFormData] = useState({
    MENUSUBCATEGORY_NAME: '',
    MENUSUBCATEGORY_STATUS: 1,
    MENUCATEGORY_ID: '',
    MENUSUBCATEGORY_ICON: '',
    MENUSUBCATEGORY_HASMENU: 0,
    MENUSUBCATEGORY_URL: '',
    MENUSUBCATEGORY_DEV: '',
  });
  
  const [showIconSelector, setShowIconSelector] = useState(false);
  
  // List of available icons from react-icons/fi
  const availableIcons = [
    'FiHome', 'FiUsers', 'FiUser', 'FiSettings', 'FiMenu', 'FiGrid', 'FiList',
    'FiPackage', 'FiShoppingBag', 'FiShoppingCart', 'FiBox', 'FiArchive',
    'FiMap', 'FiMapPin', 'FiNavigation', 'FiCompass', 'FiGlobe', 'FiFlag',
    'FiAirplay', 'FiCoffee', 'FiCamera', 'FiImage', 'FiVideo', 'FiFilm',
    'FiMusic', 'FiHeadphones', 'FiMic', 'FiRadio', 'FiTv', 'FiMonitor',
    'FiSmartphone', 'FiTablet', 'FiLaptop', 'FiHardDrive', 'FiServer',
    'FiDatabase', 'FiCloud', 'FiWifi', 'FiBluetooth', 'FiCpu', 'FiChip',
    'FiActivity', 'FiTrendingUp', 'FiTrendingDown', 'FiBarChart', 'FiBarChart2',
    'FiPieChart', 'FiLineChart', 'FiDollarSign', 'FiCreditCard', 'FiWallet',
    'FiBank', 'FiMoney', 'FiPercent', 'FiCalculator', 'FiReceipt', 'FiFile',
    'FiFileText', 'FiFolder', 'FiFolderPlus', 'FiSave', 'FiDownload', 'FiUpload',
    'FiShare', 'FiShare2', 'FiLink', 'FiExternalLink', 'FiCopy', 'FiClipboard',
    'FiEdit', 'FiEdit2', 'FiEdit3', 'FiTrash', 'FiTrash2', 'FiX', 'FiXCircle',
    'FiCheck', 'FiCheckCircle', 'FiPlus', 'FiPlusCircle', 'FiMinus', 'FiMinusCircle',
    'FiAlertCircle', 'FiAlertTriangle', 'FiInfo', 'FiHelpCircle', 'FiQuestionMark',
    'FiLock', 'FiUnlock', 'FiShield', 'FiShieldOff', 'FiKey', 'FiEye', 'FiEyeOff',
    'FiSearch', 'FiFilter', 'FiSliders', 'FiRefreshCw', 'FiRotateCw', 'FiRotateCcw',
    'FiRepeat', 'FiRefreshCcw', 'FiZap', 'FiBattery', 'FiBatteryCharging',
    'FiPower', 'FiToggleLeft', 'FiToggleRight', 'FiPlay', 'FiPause', 'FiStop',
    'FiSkipBack', 'FiSkipForward', 'FiRewind', 'FiFastForward', 'FiVolume',
    'FiVolume1', 'FiVolume2', 'FiVolumeX', 'FiBell', 'FiBellOff', 'FiMail',
    'FiInbox', 'FiSend', 'FiMessageCircle', 'FiMessageSquare', 'FiChat',
    'FiPhone', 'FiPhoneCall', 'FiPhoneIncoming', 'FiPhoneOutgoing', 'FiPhoneMissed',
    'FiPhoneOff', 'FiVideo', 'FiVideoOff', 'FiCalendar', 'FiClock', 'FiWatch',
    'FiSun', 'FiMoon', 'FiStar', 'FiHeart', 'FiThumbsUp', 'FiThumbsDown',
    'FiAward', 'FiGift', 'FiTag', 'FiBookmark', 'FiBookmarkPlus', 'FiBook',
    'FiBookOpen', 'FiBookmark', 'FiLayers', 'FiLayers2', 'FiLayout', 'FiSidebar',
    'FiColumns', 'FiMaximize', 'FiMinimize', 'FiMaximize2', 'FiMinimize2',
    'FiMove', 'FiCornerUpLeft', 'FiCornerUpRight', 'FiCornerDownLeft', 'FiCornerDownRight',
    'FiArrowUp', 'FiArrowDown', 'FiArrowLeft', 'FiArrowRight', 'FiArrowUpLeft',
    'FiArrowUpRight', 'FiArrowDownLeft', 'FiArrowDownRight', 'FiChevronUp',
    'FiChevronDown', 'FiChevronLeft', 'FiChevronRight', 'FiChevronsUp', 'FiChevronsDown',
    'FiChevronsLeft', 'FiChevronsRight', 'FiMoreHorizontal', 'FiMoreVertical',
  ];

  const fetchCategories = async () => {
    setLoadingCategories(true);
    try {
      const integratedToken = localStorage.getItem('integratedToken');
      if (!integratedToken) {
        setLoadingCategories(false);
        return;
      }

      const response = await menuCategoryApi.get('/list');
      if (response.data.status === 200) {
        setCategories(response.data.data || []);
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
    } finally {
      setLoadingCategories(false);
    }
  };

  const fetchSubCategories = async () => {
    setLoading(true);
    try {
      const integratedToken = localStorage.getItem('integratedToken');
      if (!integratedToken) {
        toast({
          title: 'Token tidak ditemukan',
          description: 'Silakan login ulang untuk mendapatkan token',
          status: 'warning',
          duration: 3000,
          isClosable: true,
        });
        setLoading(false);
        return;
      }

      const params = {};
      if (searchQuery) {
        params.search = searchQuery;
      }
      if (statusFilter !== '') {
        params.status = statusFilter;
      }
      if (categoryFilter) {
        params.categoryId = categoryFilter;
      }

      const response = await menuSubCategoryApi.get('/list', { params });
      if (response.data.status === 200) {
        setSubCategories(response.data.data || []);
      } else {
        toast({
          title: 'Error',
          description: response.data.message || 'Gagal mengambil data menu subcategory',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error('Error fetching subcategories:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Terjadi kesalahan saat mengambil data',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
    fetchSubCategories();
  }, []);

  const handleCreate = () => {
    setEditingSubCategory(null);
    setFormData({
      MENUSUBCATEGORY_NAME: '',
      MENUSUBCATEGORY_STATUS: 1,
      MENUCATEGORY_ID: '',
      MENUSUBCATEGORY_ICON: '',
      MENUSUBCATEGORY_HASMENU: 0,
      MENUSUBCATEGORY_URL: '',
      MENUSUBCATEGORY_DEV: '',
    });
    setShowIconSelector(false);
    onFormOpen();
  };

  const handleEdit = (subCategory) => {
    setEditingSubCategory(subCategory);
    setFormData({
      MENUSUBCATEGORY_NAME: subCategory.MENUSUBCATEGORY_NAME || '',
      MENUSUBCATEGORY_STATUS: subCategory.MENUSUBCATEGORY_STATUS !== undefined ? subCategory.MENUSUBCATEGORY_STATUS : 1,
      MENUCATEGORY_ID: subCategory.MENUCATEGORY_ID || '',
      MENUSUBCATEGORY_ICON: subCategory.MENUSUBCATEGORY_ICON || '',
      MENUSUBCATEGORY_HASMENU: subCategory.MENUSUBCATEGORY_HASMENU !== undefined ? subCategory.MENUSUBCATEGORY_HASMENU : 0,
      MENUSUBCATEGORY_URL: subCategory.MENUSUBCATEGORY_URL || '',
      MENUSUBCATEGORY_DEV: subCategory.MENUSUBCATEGORY_DEV || '',
    });
    setShowIconSelector(false);
    onFormOpen();
  };

  const handleSubmit = async () => {
    if (!formData.MENUSUBCATEGORY_NAME || formData.MENUSUBCATEGORY_NAME.trim() === '') {
      toast({
        title: 'Validasi gagal',
        description: 'Nama Sub Category harus diisi',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (!formData.MENUCATEGORY_ID) {
      toast({
        title: 'Validasi gagal',
        description: 'Category harus dipilih',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const CREATED_BY = userData.nip || userData.username || null;
      const UPDATED_BY = userData.nip || userData.username || null;

      if (editingSubCategory) {
        // Update
        const response = await menuSubCategoryApi.post(`/update/${editingSubCategory.MENUSUBCATEGORY_ID}`, {
          MENUSUBCATEGORY_NAME: formData.MENUSUBCATEGORY_NAME.trim(),
          MENUSUBCATEGORY_STATUS: formData.MENUSUBCATEGORY_STATUS,
          MENUCATEGORY_ID: parseInt(formData.MENUCATEGORY_ID),
          MENUSUBCATEGORY_ICON: formData.MENUSUBCATEGORY_ICON || null,
          MENUSUBCATEGORY_HASMENU: formData.MENUSUBCATEGORY_HASMENU,
          MENUSUBCATEGORY_URL: formData.MENUSUBCATEGORY_URL || null,
          MENUSUBCATEGORY_DEV: formData.MENUSUBCATEGORY_DEV || null,
          UPDATED_BY,
        });

        if (response.data.status === 200) {
          toast({
            title: 'Berhasil',
            description: 'Menu subcategory berhasil diupdate',
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
          onFormClose();
          fetchSubCategories();
        }
      } else {
        // Create
        const response = await menuSubCategoryApi.post('/', {
          MENUSUBCATEGORY_NAME: formData.MENUSUBCATEGORY_NAME.trim(),
          MENUSUBCATEGORY_STATUS: formData.MENUSUBCATEGORY_STATUS,
          MENUCATEGORY_ID: parseInt(formData.MENUCATEGORY_ID),
          MENUSUBCATEGORY_ICON: formData.MENUSUBCATEGORY_ICON || null,
          MENUSUBCATEGORY_HASMENU: formData.MENUSUBCATEGORY_HASMENU,
          MENUSUBCATEGORY_URL: formData.MENUSUBCATEGORY_URL || null,
          MENUSUBCATEGORY_DEV: formData.MENUSUBCATEGORY_DEV || null,
          CREATED_BY,
        });

        if (response.data.status === 201) {
          toast({
            title: 'Berhasil',
            description: 'Menu subcategory berhasil dibuat',
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
          onFormClose();
          fetchSubCategories();
        }
      }
    } catch (error) {
      console.error('Error saving subcategory:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Terjadi kesalahan saat menyimpan data',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleDeleteClick = (subCategory) => {
    setDeleteSubCategory(subCategory);
    onDeleteOpen();
  };

  const handleDeleteConfirm = async () => {
    if (!deleteSubCategory) return;

    try {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const DELETED_BY = userData.nip || userData.username || null;

      const response = await menuSubCategoryApi.post(`/delete/${deleteSubCategory.MENUSUBCATEGORY_ID}`, {
        DELETED_BY,
      });

      if (response.data.status === 200) {
        toast({
          title: 'Berhasil',
          description: 'Menu subcategory berhasil dihapus',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        onDeleteClose();
        setDeleteSubCategory(null);
        fetchSubCategories();
      }
    } catch (error) {
      console.error('Error deleting subcategory:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Terjadi kesalahan saat menghapus data',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleSearch = () => {
    fetchSubCategories();
  };

  const handleReset = () => {
    setSearchQuery('');
    setStatusFilter('');
    setCategoryFilter('');
    setTimeout(() => {
      fetchSubCategories();
    }, 100);
  };

  const isMobileView = useBreakpointValue({ base: true, md: false });

  // DataTable columns definition
  const columns = useMemo(
    () => [
      {
        name: 'ID',
        selector: (row) => row.MENUSUBCATEGORY_ID,
        sortable: true,
        width: '80px',
        omit: isMobileView,
      },
      {
        name: 'Nama Sub Category',
        selector: (row) => row.MENUSUBCATEGORY_NAME || '-',
        sortable: true,
        minWidth: '200px',
        cell: (row) => (
          <HStack spacing={2} align="start">
            {row.MENUSUBCATEGORY_ICON && FiIcons[row.MENUSUBCATEGORY_ICON] && (
              <Icon as={FiIcons[row.MENUSUBCATEGORY_ICON]} fontSize="lg" color="blue.500" flexShrink={0} />
            )}
            <VStack align="start" spacing={1} flex={1} minW={0}>
              <Text 
                fontWeight="600" 
                fontSize={{ base: 'sm', lg: 'md' }}
                isTruncated
                maxW="100%"
                title={row.MENUSUBCATEGORY_NAME || '-'}
              >
                {row.MENUSUBCATEGORY_NAME || '-'}
              </Text>
              {isMobileView && (
                <VStack align="start" spacing={0.5}>
                  <Text fontSize="xs" color="gray.500">
                    ID: {row.MENUSUBCATEGORY_ID} | Category: {row.MENUCATEGORY_NAME || '-'}
                  </Text>
                  <HStack spacing={2} flexWrap="wrap">
                    <Badge
                      colorScheme={row.MENUSUBCATEGORY_STATUS === 1 ? 'green' : 'red'}
                      fontSize="xs"
                    >
                      {row.MENUSUBCATEGORY_STATUS === 1 ? 'ACTIVE' : 'NOT ACTIVE'}
                    </Badge>
                    {row.MENUSUBCATEGORY_HASMENU !== undefined && (
                      <Badge
                        colorScheme={row.MENUSUBCATEGORY_HASMENU === 1 ? 'blue' : 'purple'}
                        fontSize="xs"
                      >
                        {row.MENUSUBCATEGORY_HASMENU === 1 ? 'Punya Menu' : 'Menu Langsung'}
                      </Badge>
                    )}
                    {row.MENUSUBCATEGORY_DEV && (
                      <Badge
                        colorScheme={row.MENUSUBCATEGORY_DEV === 'y' ? 'orange' : row.MENUSUBCATEGORY_DEV === 'n' ? 'green' : 'gray'}
                        fontSize="xs"
                      >
                        Dev: {row.MENUSUBCATEGORY_DEV === 'y' ? 'Iya' : 'Tidak'}
                      </Badge>
                    )}
                  </HStack>
                  {row.MENUSUBCATEGORY_URL && (
                    <Text
                      fontSize="xs"
                      color="blue.500"
                      as="a"
                      href={
                        toSecureUrl(row.MENUSUBCATEGORY_URL)
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      isTruncated
                      maxW="200px"
                      title={row.MENUSUBCATEGORY_URL}
                    >
                      {row.MENUSUBCATEGORY_URL}
                    </Text>
                  )}
                </VStack>
              )}
            </VStack>
          </HStack>
        ),
      },
      {
        name: 'Category',
        selector: (row) => row.MENUCATEGORY_NAME || '-',
        sortable: true,
        minWidth: '120px',
        cell: (row) => (
          <Badge colorScheme="purple" fontSize={{ base: 'xs', lg: 'sm' }} maxW="100%">
            <Text isTruncated title={row.MENUCATEGORY_NAME || '-'}>
              {row.MENUCATEGORY_NAME || '-'}
            </Text>
          </Badge>
        ),
        omit: isMobileView,
      },
      {
        name: 'Status',
        selector: (row) => row.MENUSUBCATEGORY_STATUS,
        sortable: true,
        width: '100px',
        cell: (row) => (
          <Badge
            colorScheme={row.MENUSUBCATEGORY_STATUS === 1 ? 'green' : 'red'}
            fontSize={{ base: 'xs', lg: 'sm' }}
            whiteSpace="nowrap"
          >
            {row.MENUSUBCATEGORY_STATUS === 1 ? 'ACTIVE' : 'NOT ACTIVE'}
          </Badge>
        ),
      },
      {
        name: 'Icon',
        selector: (row) => row.MENUSUBCATEGORY_ICON || '-',
        sortable: true,
        width: '150px',
        cell: (row) => (
          row.MENUSUBCATEGORY_ICON && FiIcons[row.MENUSUBCATEGORY_ICON] ? (
            <HStack spacing={2}>
              <Icon as={FiIcons[row.MENUSUBCATEGORY_ICON]} fontSize="xl" color="blue.500" flexShrink={0} />
              <Text 
                fontSize={{ base: 'xs', lg: 'sm' }} 
                color="gray.600"
                isTruncated
                maxW="100px"
                title={row.MENUSUBCATEGORY_ICON}
              >
                {row.MENUSUBCATEGORY_ICON}
              </Text>
            </HStack>
          ) : (
            <Text fontSize={{ base: 'xs', lg: 'sm' }} color="gray.400">-</Text>
          )
        ),
        omit: isMobileView,
      },
      {
        name: 'Punya Menu',
        selector: (row) => row.MENUSUBCATEGORY_HASMENU,
        sortable: true,
        width: '140px',
        cell: (row) => (
          <Badge
            colorScheme={row.MENUSUBCATEGORY_HASMENU === 1 ? 'blue' : 'purple'}
            fontSize={{ base: 'xs', lg: 'sm' }}
            whiteSpace="nowrap"
          >
            {row.MENUSUBCATEGORY_HASMENU === 1 ? 'Ya' : 'Menu Langsung'}
          </Badge>
        ),
        omit: isMobileView,
      },
      {
        name: 'Development',
        selector: (row) => row.MENUSUBCATEGORY_DEV || '-',
        sortable: true,
        width: '120px',
        cell: (row) => (
          <Badge
            colorScheme={row.MENUSUBCATEGORY_DEV === 'y' ? 'orange' : row.MENUSUBCATEGORY_DEV === 'n' ? 'green' : 'gray'}
            fontSize={{ base: 'xs', lg: 'sm' }}
            whiteSpace="nowrap"
          >
            {row.MENUSUBCATEGORY_DEV === 'y' ? 'Iya' : row.MENUSUBCATEGORY_DEV === 'n' ? 'Tidak' : '-'}
          </Badge>
        ),
        omit: isMobileView,
      },
      {
        name: 'URL',
        selector: (row) => row.MENUSUBCATEGORY_URL || '-',
        sortable: true,
        minWidth: '180px',
        cell: (row) => (
          row.MENUSUBCATEGORY_URL ? (
            <Text
              fontSize={{ base: 'xs', lg: 'sm' }}
              color="blue.500"
              as="a"
              href={
                toSecureUrl(row.MENUSUBCATEGORY_URL)
              }
              target="_blank"
              rel="noopener noreferrer"
              maxW="100%"
              isTruncated
              title={row.MENUSUBCATEGORY_URL}
              _hover={{ textDecoration: 'underline' }}
              display="block"
            >
              {row.MENUSUBCATEGORY_URL}
            </Text>
          ) : (
            <Text fontSize={{ base: 'xs', lg: 'sm' }} color="gray.400">-</Text>
          )
        ),
        omit: isMobileView,
      },
      {
        name: 'Created By',
        selector: (row) => row.CREATED_BY || '-',
        sortable: true,
        width: '120px',
        cell: (row) => (
          <Text 
            fontSize={{ base: 'xs', lg: 'sm' }}
            isTruncated
            maxW="100%"
            title={row.CREATED_BY || '-'}
          >
            {row.CREATED_BY || '-'}
          </Text>
        ),
        omit: isMobileView,
      },
      {
        name: 'Created Time',
        selector: (row) => row.CREATED_TIME || '-',
        sortable: true,
        width: '160px',
        cell: (row) => (
          <Text 
            fontSize={{ base: 'xs', lg: 'sm' }}
            isTruncated
            maxW="100%"
            title={row.CREATED_TIME ? new Date(row.CREATED_TIME).toLocaleString('id-ID') : '-'}
          >
            {row.CREATED_TIME ? new Date(row.CREATED_TIME).toLocaleString('id-ID') : '-'}
          </Text>
        ),
        omit: isMobileView,
      },
      {
        name: 'Aksi',
        cell: (row) => (
          <HStack spacing={1} justify="center">
            <IconButton
              icon={<FiEdit />}
              size={{ base: 'xs', lg: 'sm' }}
              colorScheme="blue"
              variant="ghost"
              onClick={() => handleEdit(row)}
              aria-label="Edit"
            />
            <IconButton
              icon={<FiTrash2 />}
              size={{ base: 'xs', lg: 'sm' }}
              colorScheme="red"
              variant="ghost"
              onClick={() => handleDeleteClick(row)}
              aria-label="Delete"
            />
          </HStack>
        ),
        width: '100px',
      },
    ],
    [isMobileView]
  );

  // Filtered data for DataTable
  const filteredData = useMemo(() => {
    return subCategories;
  }, [subCategories]);

  // Filter active categories for dropdown
  const activeCategories = useMemo(() => {
    return categories.filter(cat => cat.MENUCATEGORY_STATUS === 1);
  }, [categories]);

  return (
    <Box p={{ base: 2, sm: 3, md: 4, lg: 6 }} w="100%" maxW="100%" overflowX="hidden">
      <VStack spacing={{ base: 3, md: 4, lg: 6 }} align="stretch" w="100%">
        <VStack spacing={3} align="stretch" w="100%">
          <Heading size={{ base: 'md', sm: 'lg', md: 'xl' }} textAlign={{ base: 'center', sm: 'left' }}>
            Manage Menu Sub Category
          </Heading>
          <HStack spacing={2} flexWrap="wrap" w="100%" justify={{ base: 'center', sm: 'flex-start' }}>
            <Button
              leftIcon={<FiRefreshCw />}
              onClick={fetchSubCategories}
              isLoading={loading}
              size={{ base: 'sm', md: 'md' }}
              flex={{ base: '1 1 100%', sm: '0 1 auto' }}
              minW={{ base: '100%', sm: '120px' }}
            >
              Refresh
            </Button>
            <Button
              leftIcon={<FiPlus />}
              colorScheme="blue"
              onClick={handleCreate}
              size={{ base: 'sm', md: 'md' }}
              flex={{ base: '1 1 100%', sm: '0 1 auto' }}
              minW={{ base: '100%', sm: '160px' }}
            >
              Tambah Sub Category
            </Button>
          </HStack>
        </VStack>

        <Card>
          <CardBody p={{ base: 3, md: 4, lg: 6 }}>
            <VStack spacing={4} align="stretch">
              {/* Search and Filter */}
              <VStack spacing={3} align="stretch" w="100%">
                <InputGroup w="100%" size={{ base: 'md', md: 'lg' }}>
                  <Input
                    placeholder="Cari nama sub category..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        handleSearch();
                      }
                    }}
                    fontSize={{ base: 'sm', md: 'md' }}
                    pr={{ base: '40px', md: '50px' }}
                  />
                  <InputRightElement width={{ base: '40px', md: '50px' }}>
                    <IconButton
                      icon={<FiSearch />}
                      size={{ base: 'xs', md: 'sm' }}
                      variant="ghost"
                      onClick={handleSearch}
                      aria-label="Search"
                    />
                  </InputRightElement>
                </InputGroup>
                <SimpleGrid columns={{ base: 1, sm: 2, md: 4 }} spacing={3} w="100%">
                  <Select
                    placeholder="Filter Category"
                    value={categoryFilter}
                    onChange={(e) => setCategoryFilter(e.target.value)}
                    size={{ base: 'md', md: 'lg' }}
                    fontSize={{ base: 'sm', md: 'md' }}
                  >
                    {categories.map((cat) => (
                      <option key={cat.MENUCATEGORY_ID} value={cat.MENUCATEGORY_ID}>
                        {cat.MENUCATEGORY_NAME}
                      </option>
                    ))}
                  </Select>
                  <Select
                    placeholder="Filter Status"
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    size={{ base: 'md', md: 'lg' }}
                    fontSize={{ base: 'sm', md: 'md' }}
                  >
                    <option value="1">ACTIVE</option>
                    <option value="0">NOT ACTIVE</option>
                  </Select>
                  <Button
                    onClick={handleSearch}
                    colorScheme="blue"
                    size={{ base: 'md', md: 'lg' }}
                    w="100%"
                    fontSize={{ base: 'sm', md: 'md' }}
                  >
                    Cari
                  </Button>
                  <Button
                    onClick={handleReset}
                    variant="outline"
                    size={{ base: 'md', md: 'lg' }}
                    w="100%"
                    fontSize={{ base: 'sm', md: 'md' }}
                  >
                    Reset
                  </Button>
                </SimpleGrid>
              </VStack>

              {/* DataTable */}
              {loading && subCategories.length === 0 ? (
                <Box textAlign="center" py={8}>
                  <Spinner size={{ base: 'lg', md: 'xl' }} />
                </Box>
              ) : (
                <Box 
                  overflowX="auto" 
                  w="100%" 
                  maxW="100%"
                  css={{
                    '&::-webkit-scrollbar': {
                      height: '8px',
                    },
                    '&::-webkit-scrollbar-track': {
                      background: '#f1f1f1',
                      borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      background: '#888',
                      borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                      background: '#555',
                    },
                  }}
                >
                  <DataTable
                    columns={columns}
                    data={filteredData}
                    progressPending={loading}
                    pagination
                    paginationPerPage={isMobileView ? 5 : 10}
                    paginationRowsPerPageOptions={isMobileView ? [5, 10, 20] : [10, 20, 50, 100]}
                    highlightOnHover
                    pointerOnHover
                    responsive
                    fixedHeader={!isMobileView}
                    fixedHeaderScrollHeight={isMobileView ? undefined : "600px"}
                    dense={isMobileView}
                    customStyles={{
                      table: {
                        style: {
                          tableLayout: 'auto',
                          minWidth: isMobileView ? '100%' : '800px',
                        },
                      },
                      tableWrapper: {
                        style: {
                          overflowX: 'auto',
                          width: '100%',
                        },
                      },
                      cells: {
                        style: {
                          paddingLeft: isMobileView ? '6px' : '12px',
                          paddingRight: isMobileView ? '6px' : '12px',
                          paddingTop: isMobileView ? '8px' : '12px',
                          paddingBottom: isMobileView ? '8px' : '12px',
                          fontSize: isMobileView ? '11px' : '14px',
                        },
                      },
                      headCells: {
                        style: {
                          paddingLeft: isMobileView ? '6px' : '12px',
                          paddingRight: isMobileView ? '6px' : '12px',
                          paddingTop: isMobileView ? '8px' : '12px',
                          paddingBottom: isMobileView ? '8px' : '12px',
                          fontWeight: '600',
                          fontSize: isMobileView ? '11px' : '14px',
                        },
                      },
                      pagination: {
                        style: {
                          paddingLeft: isMobileView ? '8px' : '12px',
                          paddingRight: isMobileView ? '8px' : '12px',
                        },
                      },
                    }}
                    noDataComponent={
                      <Box py={8} textAlign="center" px={4}>
                        <Text color="gray.500" fontSize={{ base: 'sm', md: 'md' }}>
                          Tidak ada data menu subcategory
                        </Text>
                      </Box>
                    }
                  />
                </Box>
              )}
            </VStack>
          </CardBody>
        </Card>
      </VStack>

      {/* Create/Edit Modal */}
      <Modal 
        isOpen={isFormOpen} 
        onClose={() => {
          setShowIconSelector(false);
          onFormClose();
        }} 
        size={{ base: 'full', md: 'md', lg: 'lg' }} 
        scrollBehavior="inside"
        isCentered
      >
        <ModalOverlay />
        <ModalContent mx={{ base: 0, md: 'auto' }} maxW={{ base: '100%', md: '90%', lg: '600px' }}>
          <ModalHeader fontSize={{ base: 'lg', md: 'xl' }}>
            {editingSubCategory ? 'Edit Menu Sub Category' : 'Tambah Menu Sub Category'}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={{ base: 4, md: 6 }}>
            <VStack spacing={4}>
              <FormControl isRequired>
                <FormLabel fontSize={{ base: 'sm', md: 'md' }}>Category</FormLabel>
                <Select
                  placeholder="Pilih Category"
                  value={formData.MENUCATEGORY_ID}
                  onChange={(e) =>
                    setFormData({ ...formData, MENUCATEGORY_ID: e.target.value })
                  }
                  isDisabled={loadingCategories}
                  size={{ base: 'md', md: 'lg' }}
                  fontSize={{ base: 'sm', md: 'md' }}
                >
                  {activeCategories.map((cat) => (
                    <option key={cat.MENUCATEGORY_ID} value={cat.MENUCATEGORY_ID}>
                      {cat.MENUCATEGORY_NAME}
                    </option>
                  ))}
                </Select>
                {loadingCategories && (
                  <Text fontSize="xs" color="gray.500" mt={1}>
                    Memuat categories...
                  </Text>
                )}
              </FormControl>
              <FormControl isRequired>
                <FormLabel fontSize={{ base: 'sm', md: 'md' }}>Nama Sub Category</FormLabel>
                <Input
                  placeholder="Masukkan nama sub category"
                  value={formData.MENUSUBCATEGORY_NAME}
                  onChange={(e) =>
                    setFormData({ ...formData, MENUSUBCATEGORY_NAME: e.target.value })
                  }
                  size={{ base: 'md', md: 'lg' }}
                  fontSize={{ base: 'sm', md: 'md' }}
                />
              </FormControl>
              <FormControl>
                <FormLabel fontSize={{ base: 'sm', md: 'md' }}>Icon</FormLabel>
                <VStack spacing={2} align="stretch">
                  <VStack spacing={2} align="stretch" w="100%">
                    <Input
                      placeholder="Pilih icon atau kosongkan"
                      value={formData.MENUSUBCATEGORY_ICON || ''}
                      readOnly
                      bg="gray.50"
                      size={{ base: 'md', md: 'lg' }}
                      fontSize={{ base: 'sm', md: 'md' }}
                    />
                    {formData.MENUSUBCATEGORY_ICON && FiIcons[formData.MENUSUBCATEGORY_ICON] && (
                      <HStack spacing={2} w="100%">
                        <Icon as={FiIcons[formData.MENUSUBCATEGORY_ICON]} fontSize={{ base: 'xl', md: '2xl' }} color="blue.500" />
                        <Text fontSize={{ base: 'sm', md: 'md' }} color="gray.600">
                          {formData.MENUSUBCATEGORY_ICON}
                        </Text>
                      </HStack>
                    )}
                    <HStack spacing={2} flexWrap="wrap" w="100%">
                      <Button
                        size={{ base: 'sm', md: 'md' }}
                        onClick={() => setShowIconSelector(!showIconSelector)}
                        variant={showIconSelector ? 'solid' : 'outline'}
                        colorScheme="blue"
                        flex={{ base: '1', sm: '0 1 auto' }}
                        minW={{ base: '100%', sm: 'auto' }}
                      >
                        {showIconSelector ? 'Tutup' : 'Pilih Icon'}
                      </Button>
                      {formData.MENUSUBCATEGORY_ICON && (
                        <Button
                          size={{ base: 'sm', md: 'md' }}
                          onClick={() => setFormData({ ...formData, MENUSUBCATEGORY_ICON: '' })}
                          variant="ghost"
                          colorScheme="red"
                          flex={{ base: '1', sm: '0 1 auto' }}
                          minW={{ base: '100%', sm: 'auto' }}
                        >
                          Hapus
                        </Button>
                      )}
                    </HStack>
                  </VStack>
                  {showIconSelector && (
                    <Box
                      border="1px"
                      borderColor="gray.200"
                      borderRadius="md"
                      p={{ base: 3, md: 4 }}
                      maxH={{ base: '250px', md: '300px' }}
                      overflowY="auto"
                      bg="gray.50"
                    >
                      <Text fontSize={{ base: 'xs', md: 'sm' }} fontWeight="semibold" mb={3}>
                        Pilih Icon:
                      </Text>
                      <SimpleGrid columns={{ base: 4, sm: 6, md: 8 }} spacing={{ base: 1.5, md: 2 }}>
                        {availableIcons.map((iconName) => {
                          const IconComponent = FiIcons[iconName];
                          if (!IconComponent) return null;
                          const isSelected = formData.MENUSUBCATEGORY_ICON === iconName;
                          return (
                            <Button
                              key={iconName}
                              size={{ base: 'xs', md: 'sm' }}
                              variant={isSelected ? 'solid' : 'outline'}
                              colorScheme={isSelected ? 'blue' : 'gray'}
                              onClick={() => {
                                setFormData({ ...formData, MENUSUBCATEGORY_ICON: iconName });
                                setShowIconSelector(false);
                              }}
                              title={iconName}
                              p={{ base: 1, md: 2 }}
                              minH={{ base: '32px', md: '40px' }}
                            >
                              <Icon as={IconComponent} fontSize={{ base: 'md', md: 'lg' }} />
                            </Button>
                          );
                        })}
                      </SimpleGrid>
                    </Box>
                  )}
                </VStack>
              </FormControl>
              <FormControl>
                <FormLabel fontSize={{ base: 'sm', md: 'md' }}>Status</FormLabel>
                <Select
                  value={formData.MENUSUBCATEGORY_STATUS}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      MENUSUBCATEGORY_STATUS: parseInt(e.target.value),
                    })
                  }
                  size={{ base: 'md', md: 'lg' }}
                  fontSize={{ base: 'sm', md: 'md' }}
                >
                  <option value={1}>ACTIVE</option>
                  <option value={0}>NOT ACTIVE</option>
                </Select>
              </FormControl>
              <FormControl>
                <FormLabel fontSize={{ base: 'sm', md: 'md' }}>Punya Menu?</FormLabel>
                <Select
                  value={formData.MENUSUBCATEGORY_HASMENU}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      MENUSUBCATEGORY_HASMENU: parseInt(e.target.value),
                    })
                  }
                  size={{ base: 'md', md: 'lg' }}
                  fontSize={{ base: 'sm', md: 'md' }}
                >
                  <option value={0}>Tidak (Subcategory menjadi menu langsung)</option>
                  <option value={1}>Ya (Subcategory punya menu di bawahnya)</option>
                </Select>
                <Text fontSize="xs" color="gray.500" mt={1}>
                  Pilih "Tidak" jika subcategory langsung menjadi menu tanpa menu di bawahnya
                </Text>
              </FormControl>
              <FormControl>
                <FormLabel fontSize={{ base: 'sm', md: 'md' }}>URL (jika subcategory menjadi menu langsung)</FormLabel>
                <Input
                  placeholder="Masukkan URL (opsional)"
                  value={formData.MENUSUBCATEGORY_URL}
                  onChange={(e) =>
                    setFormData({ ...formData, MENUSUBCATEGORY_URL: e.target.value })
                  }
                  isDisabled={formData.MENUSUBCATEGORY_HASMENU === 1}
                  size={{ base: 'md', md: 'lg' }}
                  fontSize={{ base: 'sm', md: 'md' }}
                />
                <Text fontSize="xs" color="gray.500" mt={1}>
                  Contoh: /admin/dashboard atau https://example.com
                </Text>
                {formData.MENUSUBCATEGORY_URL && formData.MENUSUBCATEGORY_HASMENU === 0 && (
                  <Box mt={2} p={2} bg="blue.50" borderRadius="md" border="1px" borderColor="blue.200">
                    <Text fontSize="xs" fontWeight="semibold" color="gray.600" mb={1}>
                      Preview URL:
                    </Text>
                    <Text
                      fontSize="sm"
                      color="blue.600"
                      as="a"
                      href={
                        toSecureUrl(formData.MENUSUBCATEGORY_URL)
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      wordBreak="break-all"
                    >
                      {toSecureUrl(formData.MENUSUBCATEGORY_URL)}
                    </Text>
                  </Box>
                )}
                {formData.MENUSUBCATEGORY_HASMENU === 1 && (
                  <Text fontSize="xs" color="orange.500" mt={1}>
                    URL hanya diperlukan jika subcategory menjadi menu langsung (Punya Menu = Tidak)
                  </Text>
                )}
              </FormControl>
              <FormControl>
                <FormLabel fontSize={{ base: 'sm', md: 'md' }}>Development</FormLabel>
                <Select
                  placeholder="Pilih Status Development"
                  value={formData.MENUSUBCATEGORY_DEV}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      MENUSUBCATEGORY_DEV: e.target.value,
                    })
                  }
                  size={{ base: 'md', md: 'lg' }}
                  fontSize={{ base: 'sm', md: 'md' }}
                >
                  <option value="">- Pilih Status -</option>
                  <option value="y">Iya (Sedang Development)</option>
                  <option value="n">Tidak (Tidak Development)</option>
                </Select>
              </FormControl>
            </VStack>
          </ModalBody>
          <ModalFooter 
            flexDirection={{ base: 'column', md: 'row' }}
            gap={{ base: 2, md: 0 }}
            pt={{ base: 4, md: 6 }}
          >
            <Button 
              variant="ghost" 
              mr={{ base: 0, md: 3 }}
              onClick={onFormClose}
              size={{ base: 'md', md: 'md' }}
              w={{ base: '100%', md: 'auto' }}
            >
              Batal
            </Button>
            <Button 
              colorScheme="blue" 
              onClick={handleSubmit}
              size={{ base: 'md', md: 'md' }}
              w={{ base: '100%', md: 'auto' }}
            >
              {editingSubCategory ? 'Update' : 'Simpan'}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Delete Confirmation Dialog */}
      <AlertDialog
        isOpen={isDeleteOpen}
        leastDestructiveRef={cancelRef}
        onClose={onDeleteClose}
        isCentered
        motionPreset="slideInBottom"
      >
        <AlertDialogOverlay>
          <AlertDialogContent mx={{ base: 4, md: 0 }} maxW={{ base: 'calc(100% - 32px)', md: '500px' }}>
            <AlertDialogHeader fontSize={{ base: 'md', md: 'lg' }} fontWeight="bold">
              Hapus Menu Sub Category
            </AlertDialogHeader>
            <AlertDialogBody fontSize={{ base: 'sm', md: 'md' }}>
              Apakah Anda yakin ingin menghapus menu subcategory "{deleteSubCategory?.MENUSUBCATEGORY_NAME}"?
              Tindakan ini tidak dapat dibatalkan.
            </AlertDialogBody>
            <AlertDialogFooter 
              flexDirection={{ base: 'column', md: 'row' }}
              gap={{ base: 2, md: 0 }}
            >
              <Button 
                ref={cancelRef} 
                onClick={onDeleteClose}
                w={{ base: '100%', md: 'auto' }}
                size={{ base: 'md', md: 'md' }}
              >
                Batal
              </Button>
              <Button 
                colorScheme="red" 
                onClick={handleDeleteConfirm} 
                ml={{ base: 0, md: 3 }}
                w={{ base: '100%', md: 'auto' }}
                size={{ base: 'md', md: 'md' }}
              >
                Hapus
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};

export default ManageMenuSubCategory;

